var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6971 0.800451C13.2829 -0.266817 14.7171 -0.266817 15.3029 0.800451L27.7872 23.5413C28.3835 24.6275 27.6559 26 26.4838 26H1.51617C0.344145 26 -0.383464 24.6275 0.212779 23.5413L12.6971 0.800451ZM14.0943 20.7996C13.3519 20.7996 12.7501 21.4145 12.7499 22.1728C12.7499 22.9312 13.3518 23.546 14.0943 23.546C14.8367 23.5458 15.4387 22.9311 15.4387 22.1728C15.4386 21.4146 14.8366 20.7998 14.0943 20.7996ZM14.0743 7.7995C13.3309 7.7996 12.7285 8.41618 12.7299 9.17547L12.7454 16.8299C12.7472 17.5869 13.3487 18.1992 14.0898 18.1994C14.8334 18.1994 15.4357 17.5829 15.4342 16.8234L15.4187 9.16989C15.417 8.4127 14.8156 7.7995 14.0743 7.7995Z",
    fill: "#EB434B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.141c9c03b58b016e607d01c301971601.svg";
export { ForwardRef as ReactComponent };